import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

export const toggleUserActive = async ({
  user_id,
}: {
  user_id: string;
}): Promise<ApiResponse<unknown>> => {
  return await apiClient.patch(`user/${user_id}/toggle-active`);
};

export function toggleUserActiveMutationOptions() {
  return mutationOptions<ApiResponse<unknown>, AxiosError, { user_id: string }>(
    {
      mutationFn: toggleUserActive,
    }
  );
}
